import { RcsbAnnotationConstants } from "../../../../../RcsbAnnotationConfig/RcsbAnnotationConstants";
import { TagDelimiter } from "@rcsb/rcsb-api-tools/lib/RcsbUtils/TagDelimiter";
export var TrackUtils;
(function (TrackUtils) {
    function getProvenanceConfigFormTarget(targetId, targetSource) {
        if (TagDelimiter.isRcsbId(targetId))
            return {
                name: RcsbAnnotationConstants.provenanceName.pdb,
                color: RcsbAnnotationConstants.provenanceColorCode.rcsbPdb,
            };
        else if (TagDelimiter.isModel(targetId))
            return {
                name: RcsbAnnotationConstants.provenanceName.csm,
                color: RcsbAnnotationConstants.provenanceColorCode.csm,
            };
        else
            return {
                name: targetSource,
                color: RcsbAnnotationConstants.provenanceColorCode.external,
            };
    }
    TrackUtils.getProvenanceConfigFormTarget = getProvenanceConfigFormTarget;
    function transformSourceFromTarget(targetId, source) {
        if (TagDelimiter.isModel(targetId) && source.includes("PDB_"))
            return source.replace("PDB_", "CSM ");
        else
            return source;
    }
    TrackUtils.transformSourceFromTarget = transformSourceFromTarget;
    function getProvenanceColorFromProvenance(provenance) {
        if (provenance === RcsbAnnotationConstants.provenanceName.pdb || provenance === RcsbAnnotationConstants.provenanceName.promotif)
            return RcsbAnnotationConstants.provenanceColorCode.rcsbPdb;
        return RcsbAnnotationConstants.provenanceColorCode.external;
    }
    TrackUtils.getProvenanceColorFromProvenance = getProvenanceColorFromProvenance;
})(TrackUtils || (TrackUtils = {}));
//# sourceMappingURL=TrackUtils.js.map